import { AppComponentProps } from '../../typescriptHelpers';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { antGold, antGrey } from '../styles/globalStyles';
import { Integration, IntegrationErrorType, SettingType } from '@/types';
import { displayNameForIntegrationType } from '../../helpers/integrationHelpers';
import { tagStyle } from '.././styles/globalStyles';
import IntegrationIcon from '../icons/IntegrationIcon';
import Typography from 'antd/lib/typography';
import Tag from 'antd/lib/tag';
import { displayTextForIntegrationStatus, tagColorForIntegrationStatus } from '../../helpers';
import Space from 'antd/lib/space';
import Divider from 'antd/lib/divider';
import Tooltip from 'antd/lib/tooltip';
import { Link } from 'react-router-dom';
import { createAppSettingsRouteWithSettingType } from '../../helpers/routeHelpers';
import Button from 'antd/lib/button';
import { ArrowRightOutlined } from '@ant-design/icons';

interface ReleaseStepIntegrationStatusBannerProps extends AppComponentProps {
    integrations: Integration[];
}

export const ReleaseStepIntegrationStatusBanner: React.FC<ReleaseStepIntegrationStatusBannerProps> = (
    props: ReleaseStepIntegrationStatusBannerProps,
) => {
    if (props.integrations.length === 0) {
        return <></>;
    }

    const getBannerTitle = () => {
        if (props.integrations.length == 1) {
            if (props.integrations[0].integrationError.status == IntegrationErrorType.IncompleteData) {
                return (
                    <Text style={{ fontSize: 16, fontWeight: 400, color: antGrey.grey8 }}>
                        Your{' '}
                        <Text style={{ fontSize: 16, fontWeight: 600, color: antGrey.grey8 }}>
                            {displayNameForIntegrationType(props.integrations[0].id)}{' '}
                        </Text>{' '}
                        integration needs additional setup.{' '}
                    </Text>
                );
            }

            return (
                <Text style={{ fontSize: 16, fontWeight: 400, color: antGrey.grey8 }}>
                    There&apos;s a problem with your{' '}
                    <Text style={{ fontSize: 16, fontWeight: 600, color: antGrey.grey8 }}>
                        {displayNameForIntegrationType(props.integrations[0].id)}{' '}
                    </Text>{' '}
                    integration.{' '}
                </Text>
            );
        }

        return (
            <Text style={{ fontSize: 16, fontWeight: 400, color: antGrey.grey8 }}>
                There&apos;s a problem with some of your integrations.
            </Text>
        );
    };

    const getBannerDescription = (
        <Text type="secondary" style={{ marginTop: 8 }}>
            You might not be seeing the most up-to-date information on this view.
        </Text>
    );

    const getBannerIntegrationErrors = () => {
        return props.integrations.map((integration, index) => (
            <div key={index} style={{ marginTop: 16 }}>
                <Space direction="horizontal">
                    <IntegrationIcon size={25} integrationId={integration.id} />
                    <Typography.Text
                        style={{
                            fontSize: 14,
                            fontWeight: 400,
                            color: antGrey.grey8,
                            flex: 1,
                            marginLeft: 8,
                            marginRight: 8,
                        }}
                    >
                        {displayNameForIntegrationType(integration.id)}
                    </Typography.Text>
                    <Tag color={tagColorForIntegrationStatus(integration)} style={tagStyle}>
                        {displayTextForIntegrationStatus(integration)}
                    </Tag>
                    <Divider
                        type="vertical"
                        style={{
                            height: 20,
                            borderWidth: '1px',
                            borderColor: antGrey.grey5,
                        }}
                    />
                    {integration.integrationError?.message && (
                        <div style={{ display: 'flex' }}>
                            <Tooltip title={integration.integrationError.message}>
                                <Text
                                    type="secondary"
                                    style={{
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '400px',
                                    }}
                                >
                                    {integration.integrationError.message}
                                </Text>
                            </Tooltip>
                            <Divider
                                type="vertical"
                                style={{
                                    height: 20,
                                    borderWidth: '1px',
                                    borderColor: antGrey.grey5,
                                }}
                            />
                        </div>
                    )}
                    <Link
                        to={{
                            pathname: createAppSettingsRouteWithSettingType(
                                props.orgId,
                                props.appId,
                                SettingType.Integrations,
                            ),
                            state: {
                                scrollTo: integration.capabilities[0],
                            },
                        }}
                    >
                        <Button type="link" style={{ margin: 0, paddingLeft: 0 }}>
                            Fix the issue <ArrowRightOutlined />
                        </Button>
                    </Link>
                </Space>
            </div>
        ));
    };

    return (
        <div
            style={{
                backgroundColor: antGold.gold1,
                border: `1px solid ${antGold.gold2}`,
                padding: '24px 36px',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {getBannerTitle()}
            {getBannerDescription}
            {getBannerIntegrationErrors()}
        </div>
    );
};
